import { t } from "ttag";

import S from "./NewTabWarning.module.css";

/**
 * WCAG 2.4.4 / 3.2.2 (IBM a_target_warning): a link that opens in a new tab
 * must warn users in advance. Two mechanisms, deliberately both present:
 * - `getNewTabTitle` for the link's `title` attribute, since the automated
 *   checker only reads a link's rendered `innerText` (which, like a real
 *   browser, excludes visually hidden content) plus its `title` -- title is
 *   the one thing it can detect regardless of the link's own visible text.
 * - `<NewTabWarning />`, rendered as an extra child, because `title` alone
 *   isn't announced by screen readers once the link already has real
 *   accessible content (title only becomes a name source when there's
 *   nothing else) -- this is what an actual screen reader user hears.
 *
 * `<NewTabWarning />` is a plain CSS-clipped `<span>` rather than the
 * `VisuallyHidden` component from `metabase/ui` on purpose: this module is
 * reachable from the static-viz bundle and from provider-less render paths
 * (via ExternalLink, used by visualizations/lib/formatting/value.tsx for
 * URL-type columns rendered into emails/exports), which have no
 * `MantineProvider` in the tree and don't pull in `metabase/ui`'s barrel.
 * A real Mantine component there both blew the static-viz size budget
 * (rspack.static-viz.config.js) and threw "MantineProvider was not found"
 * at render time in those contexts.
 */
export function getNewTabTitle(title?: string): string {
  const warning = t`opens in a new tab`;
  return title ? `${title} (${warning})` : warning;
}

export function NewTabWarning() {
  return <span className={S.srOnly}>{t` (opens in a new tab)`}</span>;
}
